export default __webpack_public_path__ + "static/media/defaultImage.1a5ecf78.svg";